import { useDispatch, useSelector } from 'react-redux';
import {
  selectSideBarMenuItems,
  SideBarMenuItem,
  toggleSidebar,
  selectIsSidebarOpen
} from './sidebarSlice';
import Icon from './sidebarIcon';
import ResponsiveBurgerButton from './responsive-burger-button/responsiveBurgerButton';
import { useWindowSize } from 'react-use';
import { selectIsPOCModeActive } from 'features/poc/poc-toggle/pocToggleSlice';
import { RootState } from 'app/store';
import SideBarMenuItemComponent from './sidebarMenuItem';
import { selectSiteId } from 'features/topbar/selectedSiteSlice';

const screenWidthTriggerAmount = 768;

const SideBar = () => {
  const dispatch = useDispatch();
  const siteId = useSelector(selectSiteId);

  const isSidebarOpen = useSelector(selectIsSidebarOpen);

  const isPocModeActive = useSelector(selectIsPOCModeActive);

  const sidebarMenuItems = useSelector((state: RootState) =>
    selectSideBarMenuItems(state, isPocModeActive, siteId)
  );

  const { width } = useWindowSize();

  return (
    <>
      <div className="group relative">
        <button
          onClick={() => dispatch(toggleSidebar())}
          className={`hidden md:flex fixed top-19 z-20 items-center justify-center w-6 h-6 rounded-full shadow-sm border border-neutral-500 transition-all bg-white text-black hover:bg-secondary-400 hover:border-secondary-400 hover:text-white group-hover:opacity-100 ${
            isSidebarOpen ? 'left-69 opacity-0' : 'left-15 opacity-1'
          }`}
        >
          <i
            className={`ra-icons-generic-down-arrow text-xxs flex transition-all ${
              isSidebarOpen ? 'rotate-90' : '-rotate-90'
            }`}
          ></i>
        </button>
        <div
          className={`md:fixed flex flex-col flex-nowrap md:justify-between bg-navy h-full transition-all ${
            isSidebarOpen ? 'md:w-72  md:pr-2' : 'md:w-18'
          }`}
        >
          {width < screenWidthTriggerAmount ||
          width > screenWidthTriggerAmount ? (
            <>
              <div
                className={`flex flex-col h-full overflow-hidden ${
                  isSidebarOpen ? '' : 'md:w-18'
                }`}
              >
                <div
                  className={`flex justify-center content-center items-center relative ${
                    isSidebarOpen ? 'p-2.5' : 'p-2.5'
                  }`}
                >
                  <div className="flex-row">
                    <Icon />
                  </div>
                  {width < screenWidthTriggerAmount ? (
                    <div className="absolute right-4 top-1/2 -translate-y-1/2 flex">
                      <ResponsiveBurgerButton />
                    </div>
                  ) : null}
                </div>
                <div
                  className={`overflow-y-auto h-full flex flex-col justify-between ${
                    isSidebarOpen ? 'block' : 'hidden md:block md:max-w-18'
                  }`}
                >
                  <div>
                    {width > screenWidthTriggerAmount ||
                    width < screenWidthTriggerAmount
                      ? sidebarMenuItems.map((item: SideBarMenuItem) => {
                          return (
                            <SideBarMenuItemComponent
                              key={`sidebar-menu-item-${item.id}`}
                              menuItem={item}
                            />
                          );
                        })
                      : null}
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default SideBar;
